import React from "react";
import AOS from "aos";
AOS.init();

const whatido = () => {
  return (
    <div className="container">
      <div className="row">
        <div
          className="col-md-12 text-center"
          data-aos="fade-up"
          data-aos-delay="0"
          data-aos-duration="1000"
          data-aos-easing="ease"
          data-aos-once="true"
        >
          <h2>What I Do</h2>
          <div className="space-border"></div>
        </div>
      </div>
      <div className="spacer-single"></div>
      <div className="row">
        <div
          className="col-lg-4"
          data-aos="fade"
          data-aos-delay="300"
          data-aos-duration="1000"
          data-aos-easing="ease"
          data-aos-once="true"
        >
          <div className="de_3d-box">
            <div className="d-inner">
              <i className="icon_genius id-color-2"></i>
              <div className="text">
                <h3>Design</h3>
                ⚡ Meeting with clients to discuss requirements and/or project
                progress.
                <br />⚡ Establishing design guidelines, standards, and best
                practices.
                <br />⚡ Demonstrating and receiving feedback about draft sites.
                <br />⚡ Communicating design ideas using user flows, process
                flows, site maps, and wireframes. <br />⚡ Incorporating
                functionalities and features into websites.
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4"
          data-aos="fade"
          data-aos-delay="400"
          data-aos-duration="1000"
          data-aos-easing="ease"
          data-aos-once="true"
        >
          <div className="de_3d-box">
            <div className="d-inner">
              <i className="icon_tools id-color-2"></i>
              <div className="text">
                <h3>Development</h3>⚡ Develop highly interactive Front end /
                User Interfaces for your web applications. <br />
                ⚡ Develop and manage well-functioning databases and
                applications. <br />⚡ Write effective APIs following the
                RESTful API guidelines. <br />⚡ Test software to ensure
                responsiveness and efficiency. <br />⚡ Troubleshoot, debug and
                upgrade software <br />⚡ Write technical documentation.
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-lg-4"
          data-aos="fade"
          data-aos-delay="500"
          data-aos-duration="1000"
          data-aos-easing="ease"
          data-aos-once="true"
        >
          <div className="de_3d-box">
            <div className="d-inner">
              <i className="icon_camera_alt id-color-2"></i>
              <div className="text">
                <h3>Deployment</h3>⚡ Integration of third party services such
                as Firebase/ AWS / Heroku / Netlify and Github pages. <br />⚡
                Customize the deployment with Pre-deployment checks and
                post-deployment conditions.
                <br />⚡ Creates workflows fot faster and more frequent
                deployment of software updates to the production environment
                where they can be accessed by users.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default whatido;
